export enum DirectShipmentIntentionRuleOrderType {
  INTERNATIONAL = "international",
  DOMESTIC = "domestic",
  ALL = "all",
}
